// extracted by mini-css-extract-plugin
export default {"tx":"_776b034c22","line":"d54b9321b0"};